import { EntryType, type TreeNode } from '@morph-mapper/types';
import { getKeys } from '@morph-mapper/utils';
import Queue from 'queue-fifo';
import { match } from 'ts-pattern';

// TODO: Move and combine with other definition.
const ROOT_KEY = 'root';

/**
 * Constructs a mapping from paths to IDs based on the given entries.
 * @param entries The entries to construct the mapping from.
 * @returns The mapping.
 *
 * @note This function assumes that there is always a ROOT_KEY in the entries.
 */
export const constructPathToIdMapping = (entries: Record<string, TreeNode>) => {
  const mapping = new Map<string, string>();
  // Pointer is the path to the node, starting from the root, excluding its own key.
  const queue = new Queue<{ id: string; pointer: string[] }>();
  queue.enqueue({ id: ROOT_KEY, pointer: [] });

  while (!queue.isEmpty()) {
    const { id, pointer } = queue.dequeue()!;

    match(entries[id])
      .with({ type: EntryType.Map }, (map) => {
        const path = [...pointer, map.key];
        const key = JSON.stringify(path);
        mapping.set(key, id);

        getKeys(map.children.forwardMap).forEach((childId) => {
          queue.enqueue({ id: childId, pointer: path });
        });
      })
      .otherwise((item) => {
        const path = [...pointer, item.key];
        const key = JSON.stringify(path);

        mapping.set(key, id);
      });
  }

  return mapping;
};
